import { useEffect, useState } from 'react';

export default function useWindowWidth() {
    const [w, setW] = useState(window.innerWidth);

    useEffect(() => {
        const onResizeCallback = () => {
            setW(window.innerWidth);
        };

        window.addEventListener('resize', onResizeCallback);

        return () => {
            window.removeEventListener('resize', onResizeCallback);
        };
    }, []);

    return w;
}
